export default "__VITE_ASSET__CwsoeQsb__"